/**
 * Every API response follows one of these two shapes.
 * See docs/phases/phase-01.md -> Technical Notes.
 */
export interface ApiSuccess<T> {
  data: T;
}

export interface ApiError {
  error: string;
  /** Field-level validation issues, keyed by dotted path. */
  details?: Record<string, string[]>;
}

export type ApiResponse<T> = ApiSuccess<T> | ApiError;

export function isApiError<T>(response: ApiResponse<T>): response is ApiError {
  return 'error' in response;
}
